import classNames from "classnames";
import React, { ReactNode } from "react";

type TWebsiteBuilderSettingsRowLayout = "equal-width" | "space-between";

interface IWebsiteBuilderSettingsRowProps {
  layout: TWebsiteBuilderSettingsRowLayout;
  children: ReactNode;
}

export function WebsiteBuilderSettingsRow(props: IWebsiteBuilderSettingsRowProps) {
  const {
    layout,
    children,
  } = props;

  return (
    <div className={classNames("website-builder-settings-row", {
      "equal-width": layout === "equal-width",
      "space-between": layout === "space-between",
    })}>
      {children}
    </div>
  );
}
